import { Column } from '@odin-labs/components';
import { GetSchedulesQuery } from 'apollo/generated/client-operations';
import { Moment } from 'moment';
import { PageSearchParams } from 'utils';

export type SchedulesUser = { userAccountId: string };

export type Schedule =
  GetSchedulesQuery['getCurrentSession']['user']['schedules']['edges'][number]['node'];

export type SchedulesFiltersOptions =
  GetSchedulesQuery['getCurrentSession']['user']['schedules']['filtersOptions'];

export type SchedulesFilters = Pick<
  PageSearchParams,
  | 'developerIds'
  | 'jobsiteIds'
  | 'schedulerAccountIds'
  | 'startDate'
  | 'endDate'
  | 'scheduleStatuses'
  | 'notificationsSent'
> & {
  dateRange: {
    startDate: Moment;
    endDate: Moment;
  };
  today: null;
};

export type ScheduleColumn = Column<Schedule>;

export enum ScheduleColumnName {
  Scheduler = 'scheduler',
  Jobsite = 'jobsite',
  Date = 'date',
  ScheduleStatus = 'scheduleStatus',
  NotificationStatus = 'notificationsSent',
  Actions = 'actions',
}

export type ScheduleModalValue = {
  modalAction: 'importSchedule' | 'sendNotifications';
  selectedSchedule?: Schedule;
};
